import React from 'react';
import './ScheduledTag.css';

export const ScheduledTag = ({ shadow = true }) =>
    <span className={`selected-tag${shadow ? ' shadow' : ''}`}>
        current
    </span>
